import { Link } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";
import { useState } from "react";
import "../Login/Login.less";
import logo from "../../assets/logo.png";

/**
 * Password reset is handled by Okta. This page directs users back to Okta sign-in.
 */
export default function OktaPasswordHelp() {
  const { oktaAuth } = useOktaAuth();
  const [isRedirecting, setIsRedirecting] = useState(false);

  const handleSignIn = async () => {
    setIsRedirecting(true);
    try {
      await oktaAuth.signInWithRedirect();
    } catch {
      setIsRedirecting(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="logo-container">
            <img src={logo} alt="ClinxOS Logo" className="logo-icon-img" />
            <h1>ClinxOS</h1>
          </div>
          <p className="subtitle">Password reset</p>
        </div>

        <p style={{ marginBottom: "1.5rem", textAlign: "center" }}>
          Password management is handled through your organization&apos;s Okta account.
          Sign in with Okta to reset your password from the Okta login page.
        </p>

        <div className="login-form">
          <button
            type="button"
            className={`btn btn-primary btn-block submit-btn ${isRedirecting ? "loading" : ""}`}
            disabled={isRedirecting}
            onClick={handleSignIn}
          >
            {isRedirecting ? (
              <span>
                <i className="fa fa-spinner fa-spin" /> Redirecting…
              </span>
            ) : (
              "Sign in with Okta"
            )}
          </button>
        </div>

        <p className="text-center" style={{ marginTop: "1rem" }}>
          <Link to="/login">Back to login</Link>
        </p>
      </div>
    </div>
  );
}
